import React from 'react'
import PDIComponent from '../pdi/PDIComponent'

// Fabrikada tanımlı aracı okutup seçilen deponun STOK alanına otomatik adresler
export const FabrikaCikis = () => {
    return <PDIComponent depo={true}
        role_name={"fabrika_cikis_write"}
        title="Fabrika Çıkış" radioItems={["Fabrika Çıkış", "Hasar Bildir"]} defaultRadio="Fabrika Çıkış" showSwitch={false} api="/processFactoryEntry" modalArea="Fabrika Çıkış" />
}
